import { blobToBytes } from './blob-bytes';
import type { HashInfo } from './types';

/** 超过此大小改用「首 4MB + 文件长度」的部分哈希，避免小内存机型 OOM。 */
export const FULL_HASH_LIMIT_BYTES = 64 * 1024 * 1024;
export const PARTIAL_HASH_BYTES = 4 * 1024 * 1024;

export function toHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let out = '';
  for (let i = 0; i < bytes.length; i += 1) out += bytes[i].toString(16).padStart(2, '0');
  return out;
}

export async function sha256OfBytes(bytes: Uint8Array): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', bytes as unknown as ArrayBuffer);
  return toHex(digest);
}

/**
 * 文件指纹：
 * - ≤64MB 全量 SHA-256；
 * - >64MB 取前 4MB 的 SHA-256 拼接文件长度，标记 partial，用于记录去重与显示。
 */
export async function sha256Blob(blob: Blob): Promise<HashInfo> {
  if (blob.size <= FULL_HASH_LIMIT_BYTES) {
    const bytes = await blobToBytes(blob);
    return { value: await sha256OfBytes(bytes), partial: false, bytesHashed: blob.size };
  }
  const bytes = await blobToBytes(blob.slice(0, PARTIAL_HASH_BYTES));
  return {
    value: `${await sha256OfBytes(bytes)}-${blob.size}`,
    partial: true,
    bytesHashed: PARTIAL_HASH_BYTES,
  };
}

export function hashInfoFor(metadata: { hash?: HashInfo }): string {
  return metadata.hash?.value ?? '';
}
